
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetServerSidePropsContext } from 'next';
import { DecisionsPageProps } from '@screens/Sitemap/Decisions';
import YearPublicDecisions, { PaginationPublicDecisionsPageProps, PublicDecisionsPageProps, YearPublicDecisionsPageProps, } from '@screens/Sitemap/decisions/YearPublicDecisions';
import { getPaginatedPublicDecisionProps, getPublicDecisionPaginationProps, getYearsDecisionProps, } from '@utils/serverSide/decision';
const getServerSideProps = async (ctx: GetServerSidePropsContext): Promise<{
    props: PublicDecisionsPageProps;
}> => {
    const [paginatedPublicDecisionProps, paginationPublicDecisionProps, yearsDecisionsProps] = await Promise.all([
        getPaginatedPublicDecisionProps(ctx),
        getPublicDecisionPaginationProps(ctx),
        getYearsDecisionProps(),
    ]);
    const { year } = paginatedPublicDecisionProps as YearPublicDecisionsPageProps;
    const { years } = yearsDecisionsProps as DecisionsPageProps;
    const yearIndex = years.indexOf(year);
    const nextYear = yearIndex < years.length - 1 ? years[yearIndex + 1] : null;
    const previousYear = yearIndex > 0 ? years[yearIndex - 1] : null;
    const props: PublicDecisionsPageProps = {
        ...(paginatedPublicDecisionProps as YearPublicDecisionsPageProps),
        ...(paginationPublicDecisionProps as PaginationPublicDecisionsPageProps),
        nextYear: nextYear ?? '',
        previousYear: previousYear ?? '',
    };
    return {
        // To avoid SerializableError, wrap props into `JSON.parse(JSON.stringify())`
        // Ex: https://stackoverflow.com/questions/66817759/next-js-error-serializing-res-returned-from-getserversideprops
        props: JSON.parse(JSON.stringify(props)),
    };
};
export default YearPublicDecisions;

    async function __Next_Translate__getServerSideProps__1a06c87ef46__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/sitemap/decisions/[year]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a06c87ef46__ as getServerSideProps }
  